<template>
  <VueFinalModal v-model="showShareLinkModal" :z-index-base="100000" esc-to-close content-class="pointer-events-none" @before-open="wishlistGenerateLink">
    <div class="fixed inset-0 flex">
      <div class="flex w-full items-center justify-center p-4">
        <div class="pointer-events-auto relative flex flex-col overflow-hidden rounded-3xl bg-white p-5 text-left sm:w-full sm:max-w-[800px] sm:p-10">
          <button
            class="absolute right-4 top-3 flex rounded-full p-2 transition-colors hover:bg-background-none-hover active:bg-background-none-active"
            @click="showShareLinkModal = false"
          >
            <span class="sr-only">{{ t['w.modal.close']() }}</span>
            <Icon name="close" class="size-6" />
          </button>

          <div class="mb-6 text-h4 xs:text-h2">{{ t['w.wishlist.share.title']() }}</div>

          <p v-if="creating" class="flex items-center justify-start">
            <Icon name="loading" class="mr-3 size-5 animate-spin" />
            {{ t['w.wishlist.share.creating']() }}
          </p>

          <p v-else-if="failure" class="text-text-attention">{{ t['w.wishlist.share.failed']() }}</p>

          <div v-else>
            <p class="mb-4">{{ t['w.wishlist.share.copy.text']() }}</p>
            <FloatingLabelInput v-model="wishlistLink" name="link" read-only class="w-full" />
            <div class="mt-6 flex justify-center">
              <Button class="btn btn-rounded" @click="copy()">
                {{ copiedLatched ? t['w.wishlist.share.copy.button.confirmation']() : t['w.wishlist.share.copy.button.text']() }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { useClipboard } from '@vueuse/core'
import { VueFinalModal } from 'vue-final-modal'
import Button from '~/components/button/Button.vue'
import Icon from '~/components/icon/Icon.vue'
import FloatingLabelInput from '~/components/input/FloatingLabelInput.vue'
import type { WishlistCreateLinkResponse } from '~/types/on24-klient'
import * as t from '~/messages'

const showShareLinkModal = defineModel<boolean>({ default: false })
const creating = ref(true)
const failure = ref(false)
const wishlistLink = ref<string>('')
const copiedLatched = ref(false)
const { copy, copied } = useClipboard({ source: wishlistLink })

watch(copied, (newValue) => {
  if (newValue) {
    copiedLatched.value = true
  }
})

const wishlistGenerateLink = () => {
  copiedLatched.value = false
  creating.value = true
  failure.value = false

  $fetch<WishlistCreateLinkResponse>('/api/account/wishlist/link')
    .then((response) => {
      creating.value = false

      if (response.link) {
        wishlistLink.value = response.link
      } else {
        failure.value = true
      }
    })
    .catch(() => {
      creating.value = false
      failure.value = true
    })
}
</script>
